import type { ReportGroupBy } from '../types';

export const MIN_CHART_PAGE_SIZE = 7;
export const MAX_CHART_PAGE_SIZE = 30;

const MIN_CHART_SLOT_WIDTH: Record<ReportGroupBy, number> = {
  day: 48,
  week: 90,
  month: 108,
  quarter: 112,
  year: 78,
};

/** How many periods fit in a chart of the given width without overlapping labels. */
export const getChartPageSize = (chartWidth: number, groupBy: ReportGroupBy): number => {
  if (chartWidth <= 0) {
    return MIN_CHART_PAGE_SIZE;
  }

  return Math.min(
    groupBy === 'day' ? MAX_CHART_PAGE_SIZE : 16,
    Math.max(MIN_CHART_PAGE_SIZE, Math.floor(chartWidth / MIN_CHART_SLOT_WIDTH[groupBy])),
  );
};
